var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTruckFill = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#1C9CFF",
  d: "M9 18c0 .673-.338 1.294-.89 1.662l-.113.07C6.676 20.492 5 19.55 5 18c0-.717.385-1.376 1.003-1.732l.125-.067c1.3-.633 2.872.298 2.872 1.8"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#90D5FF",
  fillRule: "evenodd",
  d: "M14.5 4c.74 0 1.384.403 1.73 1h1.628c.983 0 1.888.551 2.326 1.432l2.211 4.45.045.104q.06.163.06.337V16a2 2 0 0 1-2 2H20c0-2.187-2.218-3.558-4.126-2.78l-.184.084-.022.01-.145.078-.018.01A3 3 0 0 0 14 18h-4c0-2.187-2.218-3.558-4.126-2.78l-.184.084-.022.01-.145.078-.018.01A3 3 0 0 0 4 18h-.5l-.204-.01A2 2 0 0 1 1.5 16V6a2 2 0 0 1 2-2zm2.004 7.006h3.719l-1.835-3.69a.59.59 0 0 0-.53-.322h-1.354z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#1C9CFF",
  d: "M19 18c0 .673-.338 1.294-.89 1.662l-.113.07C16.676 20.492 15 19.55 15 18c0-.717.385-1.376 1.003-1.732l.125-.067c1.3-.633 2.872.298 2.872 1.8"
})));
export default SvgTruckFill;